import React from 'react'
import { Body } from 'components/Shell/Shell'
import { DumbField } from 'components/Wizard2/Field'
import { TextInput, DateInput } from 'components/Wizard2/fieldComponents/Form'
import DetailHeader from 'components/FilingDetail/DetailHeader'
import { GET_APOSTILLE_RECORD } from 'requests'
import '../HealthCareDirective/HealthCareDirective.scss'
import { DetailBlock, Detail } from 'components/FilingDetail/DetailBlock'
import format from 'date-fns/format'
import FormCard from 'components/FormCard/FormCard'

const APOSTILLE_FORM_TITLE = process.env.APOSTILLE_FORM_TITLE;
const APOSTILLE_NUMBER_INPUT_LABEL = process.env.APOSTILLE_NUMBER_INPUT_LABEL;
const APOSTILLE_INSTRUCTIONS = process.env.APOSTILLE_INSTRUCTIONS;
const APOSTILLE_CERTIFIED_DATE_INPUT = process.env.APOSTILLE_CERTIFIED_DATE_INPUT;
const APOSTILLE_HIDE_FILING_DATE = process.env.APOSTILLE_HIDE_FILING_DATE;
const APOSTILLE_CITY_STATE_OVERRIDE = process.env.APOSTILLE_CITY_STATE_OVERRIDE;

export default () => {
  const [record, setRecord] = React.useState(null)
  const clearRecord = () => setRecord(null)

  return (
    <Body className={`health-care-directive-page ${record ? 'record-detail-page' : ''}`}>
      {record === null ? (
        <ApostilleLookUp onRecordReceived={record => setRecord(record)} />
      ) : (
        <FilingDetails onLoginRequest={clearRecord} record={record} />
      )}
    </Body>
  )
}

const ApostilleLookUp = ({ onRecordReceived }) => {
  const [apostilleNum, setApostilleNum] = React.useState('')
  const [apostilleDate, setApostilleDate] = React.useState('')
  const [errors, setErrors] = React.useState({})
  const [serverError, setServerError] = React.useState(null)

  const checkEnter = e => {
    if (e.charCode === 13) {
      validate()
    }
  }
  const validate = () => {
    const errors = {}
    if (!apostilleNum) {
      errors.apostilleNum = 'A number is required.'
    }
    if (APOSTILLE_CERTIFIED_DATE_INPUT && !apostilleDate){
      errors.apostilleDate = 'A certified date is required.'
    }
    if (Object.keys(errors).length === 0) {
      setErrors(errors)
      submit()
    } else {
      setErrors(errors)
    }
  }
  const submit = () => {
    GET_APOSTILLE_RECORD(
      {
        APOSTILLE_NUM: apostilleNum,
        ...(APOSTILLE_CERTIFIED_DATE_INPUT ? {CERTIFIED_DATE: apostilleDate} : {})
      },
      record => {
        setServerError(null)
        onRecordReceived(record)
      },
      err => {
        setServerError(err.message)
        console.error(err)
      }
    )
  }
  return (
    <FormCard
      title={APOSTILLE_FORM_TITLE || 'Apostille & Authentication Verification'}
      seal
      leftColumn={
        <React.Fragment>
          <DumbField
            label={APOSTILLE_NUMBER_INPUT_LABEL || 'Apostille/Authentication Number'}
            fieldId="apostilleNum"
            errorMessage={errors.apostilleNum ? [errors.apostilleNum] : []}
          >
            <TextInput
              fieldId="apostilleNum"
              value={apostilleNum}
              onChange={v => {
                setApostilleNum(v)
              }}
              onKeyPress={checkEnter}
            />
          </DumbField>
          {
            APOSTILLE_CERTIFIED_DATE_INPUT &&
            <DumbField
              className="certified-date-wrapper"
              label={'Certified Date'}
              fieldId="apostilleDate"
              errorMessage={errors.apostilleDate ? [errors.apostilleDate] : []}
            >
              <DateInput
                fieldId="apostilleDate"
                value={apostilleDate}
                onChange={v => {
                  setApostilleDate(v)
                }}
                onKeyPress={checkEnter}
              />
            </DumbField>
          }
          <button className="btn btn-primary btn-raised" onClick={validate}>
            Submit
          </button>
          {serverError && (
            <span className="error animated fadeIn fast-animation">{serverError}</span>
          )}
        </React.Fragment>
      }
      rightColumn={
        <p className="hcd-description">
          {APOSTILLE_INSTRUCTIONS || `Please enter the Number on the form you were provided from the State of ${process.env.STATE_NAME} to verify the Apostille or Authentication.`}
        </p>
      }
    />
  )
}

const FilingDetails = ({ onLoginRequest, record }) => {
  const {
    ACTING_CAPACITY,
    APOSTILLE_DATE,
    APOSTILLE_NUM,
    APOSTILLE_TYPE_ID,
    CITY,
    COUNTRY,
    SEAL_STAMP,
    SIGNED_BY,
    STATE,
    CERTIFYING_SOS_NAME
  } = record
  const cityStateDetail = <Detail label="City, State" value={`${APOSTILLE_CITY_STATE_OVERRIDE?APOSTILLE_CITY_STATE_OVERRIDE:`${CITY ? CITY + ',' : ''} ${STATE || ''}`}`} />;
  return (
    <div className="detail-page-wrapper container">
      <button className="back-link" onClick={onLoginRequest}>
        {'<'} Back to lookup
      </button>
      <DetailHeader
        name={name}
        entityType={process.env.APOSTILLE_HEADER_LABEL || (APOSTILLE_TYPE_ID === 726 ? 'Apostille' : 'Authentication')}
        systemId={APOSTILLE_NUM}
        systemIdLabel={`${process.env.APOSTILLE_NUMBER_LABEL || (APOSTILLE_TYPE_ID === 726 ? 'Apostille' : 'Authentication')} Number`}
        filingDateLabel={process.env.APOSTILLE_FILING_DATE_LABEL}
        filingDate={!APOSTILLE_HIDE_FILING_DATE ? format(new Date(APOSTILLE_DATE), 'MM/dd/yyyy') : ""}
        standingBlock={false}
      />
      <div className="general-info row">
        <div className="col-lg-6 col-sm-6 column">
          <DetailBlock title="Signed Details">
            {COUNTRY ? <Detail label="Country" value={COUNTRY || ''} /> : null}
            <Detail label="Signed By" value={SIGNED_BY || ''} />
            <Detail label="Acting Capacity" value={ACTING_CAPACITY || ''} />
            <Detail label="Seal/Stamp" value={SEAL_STAMP || ''} />
            {!process.env.APOSTILLE_CITY_STATE_IN_CERTIFIED ? cityStateDetail : null}
          </DetailBlock>
        </div>
        <div className="col-lg-6 col-sm-6 column">
          <DetailBlock title="Certified Details">
            <Detail
              label="Certified Date"
              value={format(new Date(APOSTILLE_DATE), 'MM/dd/yyyy') || ''}
            />
            <Detail
              label="Certified By"
              value={`${CERTIFYING_SOS_NAME || process.env.CURRENT_SOS_NAME}, ${process.env.STATE_NAME}, ${process.env.STATE_ORG_TITLE}`}
            />
            <Detail
              label={`${process.env.APOSTILLE_NUMBER_LABEL || (APOSTILLE_TYPE_ID === 726 ? 'Apostille' : 'Authentication')} Number`}
              value={APOSTILLE_NUM}
            />
            {process.env.APOSTILLE_CITY_STATE_IN_CERTIFIED ? cityStateDetail : null}
          </DetailBlock>
        </div>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ApostilleVerification/ApostilleVerification.js